import React, { useEffect, useState, useRef } from "react";
import {
  Typography,
  Stack,
  Box,
  Grid,
  Button,
  TextField,
  Divider,
} from "@mui/material";
import moment from "moment";
import { useQuery } from "@apollo/client";
//date picker
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
//Icons
import { SiMicrosoftexcel } from "react-icons/si";
//Import from project
import "../../Style/pagestyle.scss";
import school from "../../Assets/goglobal-school.png";
import symbol from "../../Assets/tacteing.jpg";
import { GET_CASH_RECIEVING_VOUCHER_DETAILS } from "../../Schema/Report";
import { useDownloadExcel } from "react-export-table-to-excel";
import { currencyFormat, currencyFormatRiel } from "../../Function/DynamicFn";
import LoadingPage from "../Include/LoadingPage";
import EmptyData from "../Include/EmptyData";
import {
  SelectAcademicYear,
  SelectIncomeShift,
} from "../Include/DynamicSelect";

export default function CashReceivingVoucherDetails() {
  const [fromDate, setFromDate] = useState(moment().startOf("day"));
  const [toDate, setToDate] = useState(moment());
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [incomeShiftVal, setIncomeShiftVal] = useState({ id: "", title: "" });

  let academicYearFromLocal = JSON.parse(
    window.localStorage.getItem("academicYearFromLocal")
  );

  const [selectAcedemicVal, setSelectAcedemicVal] = useState(
    academicYearFromLocal
      ? academicYearFromLocal
      : {
          id: "",
          title: "",
        }
  );

  // ============================== Export to excel =======================================
  const [checkExport, setCheckExport] = useState(false);
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Cash-receiving-details-report",
    sheet: "Cash-receiving-details-report",
  });
  const handleExportExcel = () => {
    setCheckExport(true);
    setTimeout(() => {
      onDownload();
      setCheckExport(false);
    }, 2000);
  };

  //======================================= Get Report ====================================
  const { refetch } = useQuery(GET_CASH_RECIEVING_VOUCHER_DETAILS, {
    variables: {
      academicYearId: selectAcedemicVal?.id ? selectAcedemicVal?.id : null,
      fromDate: fromDate ? moment(fromDate)?.format("YYYY-MM-DD") : null,
      toDate: toDate ? moment(toDate)?.format("YYYY-MM-DD") : null,
      incomeShiftId: incomeShiftVal?.id ? incomeShiftVal?.id : "",
    },
    onCompleted: ({ invoiceListDetailReport }) => {
      // console.log("invoiceListDetailReport::", invoiceListDetailReport);
      setTableData(invoiceListDetailReport);
      setLoading(false);
    },
  });

  useEffect(() => {
    refetch();
  }, [selectAcedemicVal?.id, fromDate, toDate, incomeShiftVal?.id]);

  useEffect(() => {
    if (selectAcedemicVal?.id) {
      window.localStorage.setItem(
        "academicYearFromLocal",
        JSON.stringify(selectAcedemicVal)
      );
    }
  }, [selectAcedemicVal?.id]);

  return (
    <div className="page-container">
      <Box sx={{ maxWidth: "1600px" }}>
        <Grid container spacing={2}>
          <Grid item xs={4} sm={4} md={3} lg={2} xl={2}>
            <Typography className="search-head-title">Academic year</Typography>
            <SelectAcademicYear
              selectedVal={selectAcedemicVal}
              setSelectedVal={setSelectAcedemicVal}
              className="search-field"
            />
          </Grid>

          <Grid item xs={4} sm={4} md={3} lg={2} xl={2}>
            <Typography className="search-head-title">From</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={fromDate}
                inputFormat="dd-MM-yyyy"
                className="select-date"
                onChange={(newValue) => {
                  setLoading(true);
                  setFromDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={4} sm={4} md={3} lg={2} xl={2}>
            <Typography className="search-head-title">To</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={toDate}
                inputFormat="dd-MM-yyyy"
                className="select-date"
                onChange={(newValue) => {
                  setLoading(true);
                  setToDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <Typography className="search-head-title">Income shift</Typography>
            <SelectIncomeShift
              className="search-field"
              fromDate={fromDate}
              toDate={toDate}
              disabled={fromDate && toDate ? false : true}
              selectedVal={incomeShiftVal}
              setSelectedVal={setIncomeShiftVal}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={2} xl={2}>
            <Stack direction="row" justifyContent="right" spacing={1}>
              <Button
                className="btn-create"
                onClick={handleExportExcel}
                startIcon={
                  <SiMicrosoftexcel style={{ height: "18px", width: "18px" }} />
                }
              >
                Export
              </Button>

              {/* <ExportTuitionReport
                loading={loading}
                tableData={tableData}
                paginationData={paginationData}
                tableRef={tableRef}
              /> */}
            </Stack>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ marginTop: "20px" }}>
        <Box
          sx={{ bgcolor: "#fff", borderRadius: "10px" }}
          className="dibursement-print-container"
        >
          <Grid container>
            <Grid item xs={3}>
              <Stack direction="column">
                <img src={school} alt="school" className="logo-size" />
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Stack direction="column">
                <Stack justifyContent="center" alignItems="center">
                  <Typography className="disbursement-title-kh">
                    ព្រះរាជាណាចក្រកម្ពុជា
                  </Typography>
                  <Typography className="disbursement-title">
                    Kingdom Of Cambodia
                  </Typography>
                  <Typography className="disbursement-title-kh">
                    ជាតិ សាសនា ព្រះមហាក្សត្រ
                  </Typography>
                  <Typography className="disbursement-title">
                    Nation Region King
                  </Typography>
                  <img src={symbol} alt="Tacteing" width="145px" />
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={3}></Grid>
          </Grid>

          <Stack direction="column" justifyContent="center" alignItems="center">
            <Typography className="disbursement-table-title">
              របាយការណ៍ទទួលសាច់ប្រាក់
            </Typography>
            <Typography className="disbursement-table-title-eng">
              Cash Receiving Details
            </Typography>
          </Stack>

          <Box sx={{ paddingTop: "10px" }} ref={tableRef}>
            <table
              className="table-cash"
              style={{ width: "3000px", borderCollapse: "collapse" }}
            >
              <thead className="thead-cash">
                <tr>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    ID
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Type of Customer
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Spacial Case
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Invoice No
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Received Date
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Starting Date
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Finished Date
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Full Name
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Latin
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Gender
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Birth
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Description
                  </td>
                  <td
                    className="title-table"
                    colSpan={3}
                    style={{ textAlign: "center" }}
                  >
                    Class
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Time
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Month
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Tuition
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Admin
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Food(F)
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Van(V)
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Uniform(U)
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Material(Ma)
                  </td>
                  {/* <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Computer(GP)
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Dance(GP)
                  </td> */}
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    General Programme(GP)
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Summer Class(S)
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Rential
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Elec.
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Other(O)
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Total
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Phone Number
                  </td>
                  <td
                    className="title-table"
                    rowSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Other
                  </td>
                  <td
                    className="title-table"
                    colSpan={2}
                    style={{ textAlign: "center" }}
                  >
                    Total in Riels
                  </td>
                </tr>
                <tr>
                  <td className="title-table" style={{ textAlign: "center" }}>
                    English
                  </td>
                  <td className="title-table" style={{ textAlign: "center" }}>
                    Khmer
                  </td>
                  <td className="title-table" style={{ textAlign: "center" }}>
                    GP
                  </td>
                  <td className="title-table" style={{ textAlign: "center" }}>
                    Exchange Rate
                  </td>
                  <td className="title-table" style={{ textAlign: "center" }}>
                    Total(Riels)
                  </td>
                </tr>
              </thead>
              {loading ? (
                <tbody className="tbody-cash-reci">
                  <tr>
                    <td colSpan={20}>
                      <LoadingPage />
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody className="tbody-cash">
                  {tableData?.invoiceList?.length === 0 ? (
                    <tr>
                      <td colSpan={20}>
                        <EmptyData />
                      </td>
                    </tr>
                  ) : (
                    <>
                      <tr>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details"></td>
                        <td className="title-table-cash-details" align="center">
                          {tableData?.totalByIncomeType?.totalTuition
                            ? `$ ${currencyFormat(
                                tableData?.totalByIncomeType?.totalTuition
                              )}`
                            : `$ 0`}
                        </td>
                        <td className="title-table-cash-details" align="center">
                          {tableData?.totalByIncomeType?.totalAdminFee
                            ? `$ ${currencyFormat(
                                tableData?.totalByIncomeType?.totalAdminFee
                              )}`
                            : `$ 0`}
                        </td>
                        <td className="title-table-cash-details" align="center">
                          {tableData?.totalByIncomeType?.totalMeal
                            ? `$ ${currencyFormat(
                                tableData?.totalByIncomeType?.totalMeal
                              )}`
                            : `$ 0`}
                        </td>
                        <td className="title-table-cash-details" align="center">
                          {tableData?.totalByIncomeType?.totalTransportation
                            ? `$ ${currencyFormat(
                                tableData?.totalByIncomeType
                                  ?.totalTransportation
                              )}`
                            : `$ 0`}
                        </td>
                        <td className="title-table-cash-details" align="center">
                          {tableData?.totalByIncomeType?.totalUniform
                            ? `$ ${currencyFormat(
                                tableData?.totalByIncomeType?.totalUniform
                              )}`
                            : `$ 0`}
                        </td>
                        <td className="title-table-cash-details" align="center">
                          {tableData?.totalByIncomeType?.totalMaterial
                            ? `$ ${currencyFormat(
                                tableData?.totalByIncomeType?.totalMaterial
                              )}`
                            : `$ 0`}
                        </td>
                        {/* <td className="title-table-cash-details" align="center">
                          {tableData?.totalByIncomeType?.totalComputer
                            ? `$ ${currencyFormat(
                                tableData?.totalByIncomeType?.totalComputer
                              )}`
                            : `$ 0`}
                        </td>
                        <td className="title-table-cash-details" align="center">
                          {tableData?.totalByIncomeType?.totalDance
                            ? `$ ${currencyFormat(
                                tableData?.totalByIncomeType?.totalDance
                              )}`
                            : `$ 0`}
                        </td> */}
                        <td className="title-table-cash-details" align="center">
                          {tableData?.totalByIncomeType?.totalGeneralProgramme
                            ? `$ ${currencyFormat(
                                tableData?.totalByIncomeType?.totalGeneralProgramme
                              )}`
                            : `$ 0`}
                        </td>
                        <td className="title-table-cash-details" align="center">
                          {tableData?.totalByIncomeType?.totalSummerClass
                            ? `$ ${currencyFormat(
                                tableData?.totalByIncomeType?.totalSummerClass
                              )}`
                            : `$ 0`}
                        </td>
                        <td className="title-table-cash-details" align="center">
                          {tableData?.totalByIncomeType?.totalRentail
                            ? `$ ${currencyFormat(
                                tableData?.totalByIncomeType?.totalRentail
                              )}`
                            : `$ 0`}
                        </td>
                        <td className="title-table-cash-details" align="center">
                          {tableData?.totalByIncomeType?.totalElectricity
                            ? `$ ${currencyFormat(
                                tableData?.totalByIncomeType?.totalElectricity
                              )}`
                            : `$ 0`}
                        </td>
                        <td className="title-table-cash-details" align="center">
                          {tableData?.totalByIncomeType?.totalOther
                            ? `$ ${currencyFormat(
                                tableData?.totalByIncomeType?.totalOther
                              )}`
                            : `$ 0`}
                        </td>
                        <td className="title-table-cash-details" align="center">
                          {tableData?.totalByIncomeType?.totalOfAll
                            ? `$ ${currencyFormat(
                                tableData?.totalByIncomeType?.totalOfAll
                              )}`
                            : `$ 0`}
                        </td>
                        <td
                          className="title-table-cash-details"
                          align="center"
                        ></td>
                        <td
                          className="title-table-cash-details"
                          align="center"
                        ></td>
                        <td
                          className="title-table-cash-details"
                          align="center"
                        ></td>
                        <td className="title-table-cash-details" align="center">
                          {tableData?.totalByIncomeType?.totalOfAllInRiels
                            ? `${currencyFormatRiel(
                                tableData?.totalByIncomeType?.totalOfAllInRiels
                              )} ៛`
                            : ""}
                        </td>
                      </tr>

                      {tableData?.invoiceList?.map((row, index) => {
                        // console.log("row::", row);
                        return (
                          <tr key={index}>
                            <td className="title-table" align="center">
                              {row?.studentId}
                            </td>
                            <td className="title-table" align="center">
                              {row?.typeOfCustomer}
                            </td>
                            <td className="title-table" align="center">
                              {row?.specialCase}
                            </td>
                            <td className="title-table" align="center">
                              {row?.invoiceId?.padStart(6, '0')}
                            </td>
                            <td className="title-table" align="center">
                              {row?.receivedDate
                                ? moment(row?.receivedDate).format(
                                    "DD-MMM-YYYY"
                                  )
                                : ""}
                            </td>
                            <td className="title-table" align="center">
                              {row?.startingDate
                                ? moment(row?.startingDate).format(
                                    "DD-MMM-YYYY"
                                  )
                                : ""}
                            </td>
                            <td className="title-table" align="center">
                              {row?.finishDate
                                ? moment(row?.finishDate).format("DD-MMM-YYYY")
                                : ""}
                            </td>
                            <td className="title-table" align="left">
                              {row?.studentFullName}
                            </td>
                            <td className="title-table" align="left">
                              {row?.studentLatinName}
                            </td>
                            <td className="title-table" align="center">
                              {row?.sex}
                            </td>
                            <td className="title-table" align="center">
                              {moment(row?.birthday).format("DD-MMM-yyyy")}
                            </td>
                            <td className="title-table" align="center">
                              {row?.descriptionType}
                            </td>
                            <td className="title-table" align="center">
                              {row?.englishClass}
                            </td>
                            <td className="title-table" align="center">
                              {row?.khmerClass}
                            </td>
                            <td className="title-table" align="center">
                              {row?.generalProgrameClass}
                            </td>
                            <td className="title-table" align="center">
                              {row?.time}
                            </td>
                            <td className="title-table" align="center">
                              {row?.months}
                            </td>
                            <td className="title-table" align="center">
                              {row?.tuition
                                ? `$ ${currencyFormat(row?.tuition)}`
                                : ""}
                            </td>
                            <td className="title-table" align="center">
                              {row?.adminFee
                                ? `$ ${currencyFormat(row?.adminFee)}`
                                : ""}
                            </td>
                            <td className="title-table" align="center">
                              {row?.meal
                                ? `$ ${currencyFormat(row?.meal)}`
                                : ""}
                            </td>
                            <td className="title-table" align="center">
                              {row?.transportation
                                ? `$ ${currencyFormat(row?.transportation)}`
                                : ""}
                            </td>
                            <td className="title-table" align="center">
                              {row?.uniform
                                ? `$ ${currencyFormat(row?.uniform)}`
                                : ""}
                            </td>
                            <td className="title-table" align="center">
                              {row?.material
                                ? `$ ${currencyFormat(row?.material)}`
                                : ""}
                            </td>
                            {/* <td className="title-table" align="center">
                              {row?.computer
                                ? `$ ${currencyFormat(row?.computer)}`
                                : ""}
                            </td>
                            <td className="title-table" align="center">
                              {row?.dance
                                ? `$ ${currencyFormat(row?.dance)}`
                                : ""}
                            </td> */}
                            <td className="title-table" align="center">
                              {row?.generalProgramme
                                ? `$ ${currencyFormat(row?.generalProgramme)}`
                                : ""}
                            </td>
                            <td className="title-table" align="center">
                              {row?.summerClass
                                ? `$ ${currencyFormat(row?.summerClass)}`
                                : ""}
                            </td>
                            <td className="title-table" align="center">
                              {row?.rentail
                                ? `$ ${currencyFormat(row?.rentail)}`
                                : ""}
                            </td>
                            <td className="title-table" align="center">
                              {row?.electricity
                                ? `$ ${currencyFormat(row?.electricity)}`
                                : ""}
                            </td>
                            <td className="title-table" align="center">
                              {row?.other
                                ? `$ ${currencyFormat(row?.other)}`
                                : ""}
                            </td>
                            <td className="title-table" align="center">
                              {row?.total
                                ? `$ ${currencyFormat(row?.total)}`
                                : ""}
                            </td>
                            {row?.phoneNumberFather &&
                            row?.phoneNumberMother ? (
                              <td className="title-table" align="center">
                                {row?.phoneNumberFather
                                  ? row?.phoneNumberFather
                                  : ""}{" "}
                                /{" "}
                                {row?.phoneNumberMother
                                  ? row?.phoneNumberMother
                                  : ""}
                              </td>
                            ) : row?.phoneNumberFather ? (
                              <td className="title-table" align="center">
                                {row?.phoneNumberFather
                                  ? row?.phoneNumberFather
                                  : ""}
                              </td>
                            ) : (
                              <td className="title-table" align="center">
                                {row?.phoneNumberMother
                                  ? row?.phoneNumberMother
                                  : ""}
                              </td>
                            )}
                            <td className="title-table" align="center">
                              {row?.remark ? row?.remark : ""}
                            </td>
                            <td className="title-table" align="center">
                              {row?.exchangeRate
                                ? currencyFormatRiel(row?.exchangeRate)
                                : ""}
                            </td>
                            <td className="title-table" align="center">
                              {row?.totalInRiels
                                ? `${currencyFormatRiel(row?.totalInRiels)} ៛`
                                : ""}
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  )}
                </tbody>
              )}
            </table>

            {/* <table style={{ width: "100%", display: "none" }}>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  នាយិការង
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  Deputy of School Principal
                </td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  ប្រធានកិច្ចការហិរញ្ញវត្ថុ
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  Financial Affairs Director
                </td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  អ្នករៀបចំ
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  Prepare by
                </td>
              </tr>
            </table> */}
          </Box>

          {/* <Box sx={{ marginTop: "10px" }}>
            <Grid container spacing={0.5}>
              <Grid item xs={2.5}>
                <Typography className="number-text">
                  ចំនួនទឹកប្រាក់ជាអក្សរ ៖
                </Typography>
              </Grid>
              <Grid item xs={9.5}>
                <Typography className="number-text">
                  {ConvertToKhmerWordsDollar(totalPrice)}
                </Typography>
              </Grid>
              <Grid item xs={2.5}>
                <Typography className="number-text">
                  Amount in words ៖
                </Typography>
              </Grid>
              <Grid item xs={9.5}>
                <Typography className="number-text">
                  {ConvertToEnglishWordsDollar(totalPrice)}
                </Typography>
              </Grid>
            </Grid>
          </Box> */}
          <Box sx={{ marginTop: "20px" }}>
            <Grid container>
              <Grid item xs={4}>
                <Stack direction="column" alignItems="center">
                  <Typography className="disbursement-table-title">
                    នាយិការង
                  </Typography>
                  <Typography
                    className="number-text"
                    style={{ fontWeight: "bold" }}
                  >
                    Deputy of School Principal
                  </Typography>
                  <Typography className="disbursement-table-title" mt={10}>
                    វេត ស្រីម៉ៅ
                  </Typography>
                  <Divider
                    style={{
                      width: "140px",
                      marginTop: "2px",
                      border: "1px solid rgba(15, 129, 194, 0.5)",
                    }}
                  />
                  <Typography className="number-text" mt={1}>
                    Date: .......................
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column" alignItems="center" mt={1}>
                  <Typography className="disbursement-table-title">
                    ប្រធានកិច្ចការហិរញ្ញវត្ថុ
                  </Typography>
                  <Typography
                    className="number-text"
                    style={{ fontWeight: "bold" }}
                  >
                    Financial Affairs Director
                  </Typography>
                  <Typography className="disbursement-table-title" mt={10}>
                    ខូវ ស៊ូខេង
                  </Typography>
                  <Divider
                    style={{
                      width: "140px",
                      marginTop: "2px",
                      border: "1px solid rgba(15, 129, 194, 0.5)",
                    }}
                  />
                  <Typography className="number-text" mt={1}>
                    Date: .......................
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column" alignItems="center" mt={2}>
                  <Typography className="disbursement-table-title">
                    អ្នករៀបចំ
                  </Typography>
                  <Typography
                    className="number-text"
                    style={{ fontWeight: "bold" }}
                  >
                    Prepare by
                  </Typography>
                  <Typography className="disbursement-table-title" mt={10}>
                    ស៊ុន ផាត់សន
                  </Typography>
                  <Divider
                    style={{
                      width: "140px",
                      marginTop: "2px",
                      border: "1px solid rgba(15, 129, 194, 0.5)",
                    }}
                  />
                  <Typography className="number-text" mt={1}>
                    Date: .......................
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
